import { ActionType } from "../action-types";
import { Dispatch } from "redux";
import { Action } from "../actions/index";

import { message } from 'antd';

import { GrantViewTypes, QueryViewTypes, InteractionTypes, MainViewTypes, TooltipTypes, UserManagementTypes } from "../../types/data";

import {
  getBackendDataAPI, // test
  getGrantIdListAPI,
  getGrantViewDataAPI,
  getPIViewDataAPI,
  getPIViewCardListDataAPI,
  getPIViewPredictedCardListDataAPI,
  getImpactStatisticsViewDataAPI,
  getGrantIdListUsingGrantFieldAPI,

  getImpactEntityViewDirectPaperDataAPI,
  getImpactEntityViewDirectPatentDataAPI,
  getImpactEntityViewDirectClinicalTrialDataAPI,
  getImpactEntityViewDirectClinicalTrialTypeDataAPI,
  getImpactEntityViewIndirectPatentDataAPI,
  getImpactEntityViewIndirectClinicalTrialDataAPI,
  getImpactEntityViewIndirectClinicalTrialTypeDataAPI,
  getImpactEntityViewIndirectPolicyDataAPI,
  getImpactEntityViewIndirectPolicySourceCountryDataAPI,
  getImpactEntityViewIndirectPolicySourceTitleDataAPI,
  getImpactEntityViewIndirectNewsfeedDataAPI,

  searchImpactEntityViewPaperDataAPI,
  searchImpactEntityViewPatentDataAPI,
  searchImpactEntityViewClinicalTrialDataAPI,
  searchImpactEntityViewPolicyDataAPI,

  // getNameAPI,
  getMainViewDataAPI,
  getMainViewImpactSummaryTableDataAPI,
  getMainViewlayoutOptimizationParamsAPI,

  // user management
  getLoginResultAPI,
  getRegisterResultAPI,
  getVerifyEmailResultAPI,
  getForgetPasswordResultAPI,
  getResetPasswordResultAPI,
  getDeleteAccountResultAPI,
} from "../../router/api";

// test
export const getBackendData = (params: number) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_BACKEND_DATA,
      payload: await getBackendDataAPI(params),
    });
  };
};


// =============================
// ===== side view (begin) =====
// =============================

// --- Query View (begin) ---
export const getGrantIdList = (params: QueryViewTypes.QueryViewAPIParams) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_GRANT_ID_LIST,
      payload: await getGrantIdListAPI(params),
    });
  };
};
export const getGrantIdListUsingGrantField = (grant_topic_code_list: number[], grant_id_list: string[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_GRANT_ID_LIST_USING_GRANT_FIELD,
      payload: await getGrantIdListUsingGrantFieldAPI(grant_topic_code_list, grant_id_list),
    });
  };
};
// --- Query View (end) ---


// --- Grant View (begin) ---
export const getGrantViewData = (params: string[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_GRANT_VIEW_DATA,
      payload: await getGrantViewDataAPI(params),
    });
  };
};
// ui request (no backend communication)
export const setSelectedGrantTopicList = (params: GrantViewTypes.SelectedGrantTopicUnit[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.SET_SELECTED_GRANT_TOPIC_LIST,
      selectedGrantTopicList: params,
    });
  };
};
// // abandon this function: it's a repeat of another function: getGrantViewData
// export const getGrantViewFieldSubviewData = (params: string[]) => {
//   return async function (dispatch: Dispatch<Action>) {
//     dispatch({
//       type: ActionType.GET_GRANT_VIEW_FIELD_SUBVIEW_DATA,
//       payload: await getGrantViewDataAPI(params),
//     });
//   };
// };
// --- Grant View (end) ---


// --- PI View (begin) ---
export const getPIViewData = (params: string[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_PI_VIEW_DATA,
      payload: await getPIViewDataAPI(params),
    });
  };
};
export const getPIViewCardListData = (grant_id_list: string[], selected_university: string, selected_sort_metric: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_PI_VIEW_CARD_LIST_DATA,
      payload: await getPIViewCardListDataAPI(grant_id_list, selected_university, selected_sort_metric),
    });
  };
};
export const getPIViewPredictedCardListData = (predicted_grant_id_list: string[], global_predicted_grant_id_list: string[], selected_university: string, selected_sort_metric: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_PI_VIEW_PREDICTED_CARD_LIST_DATA,
      payload: await getPIViewPredictedCardListDataAPI(predicted_grant_id_list, global_predicted_grant_id_list, selected_university, selected_sort_metric),
    });
  };
};
// --- PI View (end) ---


// --- Impact Statistics View [upper-right corner view] (begin) ---
export const getImpactStatViewData = (params: string[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_STATISTICS_VIEW_DATA,
      payload: await getImpactStatisticsViewDataAPI(params),
    });
  };
};
// --- Impact Statistics View [upper-right corner view] (end) ---


// --- Impact Entity View [lower-right corner view] (begin) ---
export const getImpactEntityViewDirectPaperData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_PAPER_DATA,
      payload: await getImpactEntityViewDirectPaperDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewDirectPatentData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_PATENT_DATA,
      payload: await getImpactEntityViewDirectPatentDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewDirectClinicalTrialData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_DATA,
      payload: await getImpactEntityViewDirectClinicalTrialDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewDirectClinicalTrialTypeData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_DIRECT_CLINICAL_TRIAL_TYPE_DATA,
      payload: await getImpactEntityViewDirectClinicalTrialTypeDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectPatentData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_PATENT_DATA,
      payload: await getImpactEntityViewIndirectPatentDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectClinicalTrialData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_DATA,
      payload: await getImpactEntityViewIndirectClinicalTrialDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectClinicalTrialTypeData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_CLINICAL_TRIAL_TYPE_DATA,
      payload: await getImpactEntityViewIndirectClinicalTrialTypeDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectPolicyData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_DATA,
      payload: await getImpactEntityViewIndirectPolicyDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectPolicySourceCountryData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_COUNTRY_DATA,
      payload: await getImpactEntityViewIndirectPolicySourceCountryDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectPolicySourceTitleData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_POLICY_SOURCE_TITLE_DATA,
      payload: await getImpactEntityViewIndirectPolicySourceTitleDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
export const getImpactEntityViewIndirectNewsfeedData = (grant_id_list: string[], entity_topic: string, entity_level: string, grant_field_id:string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_IMPACT_ENTITY_VIEW_INDIRECT_NEWSFEED_DATA,
      payload: await getImpactEntityViewIndirectNewsfeedDataAPI(grant_id_list, entity_topic, entity_level, grant_field_id),
    });
  };
};
// --- Impact Entity View [lower-right corner view] (end) ---







// =============================
// ====== side view (end) ======
// =============================









// TODO: clean the code below (@yifang)









export const searchImpactEntityViewPaperData = (grant_id_list: string[], search_keyword: string, entity_level: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.SEARCH_IMPACT_ENTITY_VIEW_PAPER_DATA,
      payload: await searchImpactEntityViewPaperDataAPI(grant_id_list, search_keyword, entity_level),
    });
  };
};

export const searchImpactEntityViewPatentData = (grant_id_list: string[], search_keyword: string, entity_level: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.SEARCH_IMPACT_ENTITY_VIEW_PATENT_DATA,
      payload: await searchImpactEntityViewPatentDataAPI(grant_id_list, search_keyword, entity_level),
    });
  };
};

export const searchImpactEntityViewClinicalTrialData = (grant_id_list: string[], search_keyword: string, entity_level: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.SEARCH_IMPACT_ENTITY_VIEW_CLINICAL_TRIAL_DATA,
      payload: await searchImpactEntityViewClinicalTrialDataAPI(grant_id_list, search_keyword, entity_level),
    });
  };
};

export const searchImpactEntityViewPolicyData = (grant_id_list: string[], search_keyword: string, entity_level: string) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.SEARCH_IMPACT_ENTITY_VIEW_POLICY_DATA,
      payload: await searchImpactEntityViewPolicyDataAPI(grant_id_list, search_keyword, entity_level),
    });
  };
};
// ===== side view (end) =====



// ===== mainview (begin) =====
// (1) data request
export const updateMainViewLoadingLabel = (label: string) => {   // for streaming output progress manager
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL,
      mainViewLoadingLabel: label,
    });
  };
};
// opt 1: using streaming output progress manager
export const clearMainViewData = () => {
  // only in QueryView > handleConfirmButton(): to clean previous mainview data
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.GET_MAINVIEW_DATA,
      mainviewData: {},
    });
  };
};
export const getMainViewData = (
  fieldLevelDict: InteractionTypes.UIParamFieldLevelRangeDict,
  grantIDList: string[]
) => {
  return async function (dispatch: Dispatch<Action>) {
    // 立即设置初始状态，确保用户看到 loading 开始
    dispatch({ type: ActionType.UPDATE_MAIN_VIEW_LOADING, isMainViewLoading: true });
    dispatch({
      type: ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL,
      mainViewLoadingLabel: 'Loading'
    });
    // console.log(
    //   `[Action Creator] ${new Intl.DateTimeFormat('en-US', {
    //     timeZone: 'America/New_York',   // 换成你的本地时区
    //     year: 'numeric',
    //     month: '2-digit',
    //     day: '2-digit',
    //     hour: '2-digit',
    //     minute: '2-digit',
    //     second: '2-digit'
    //   }).format(new Date())}`
    // );

    const onProgress = (msg: string) => {
      // console.log(`[Action Creator] onProgress triggered at ${new Date().toISOString()}: ${msg}`);
      // 使用 requestAnimationFrame 确保 UI 有时间渲染每个状态
      // requestAnimationFrame(() => {
        dispatch({
          type: ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL,
          mainViewLoadingLabel: msg,
        });
      // });
    };
    const onDone = () => {
      console.log(`[Action Creator] onDone callback triggered at ${new Date().toISOString()}`);
      // 延迟一点显示 "Finalizing..."，让用户能看到最后的进度消息
      setTimeout(() => {
        dispatch({
          type: ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL,
          mainViewLoadingLabel: 'Finalizing...',
        });
      }, 500); // 500ms延迟，让用户看到最后的进度
    };

    try {
      const payload = await getMainViewDataAPI(fieldLevelDict, grantIDList, onProgress, onDone);

      dispatch({
        type: ActionType.GET_MAINVIEW_DATA,
        mainviewData: payload ?? {},
      });

      return payload;
    } catch (err) {
      dispatch({
        type: ActionType.UPDATE_MAIN_VIEW_LOADING_LABEL,
        mainViewLoadingLabel: 'Backend unavailable. Please retry.',
      });
      throw err;
    } finally {
      dispatch({ type: ActionType.UPDATE_MAIN_VIEW_LOADING, isMainViewLoading: false });
    }

    // const payload = await getMainViewDataAPI(fieldLevelDict, grantIDList, onProgress, onDone);
    // // 把最终数据塞进 store（根据你项目里已有的 action 类型来）
    // dispatch({
    //   type: ActionType.GET_MAINVIEW_DATA, // 如果你已有这个类型
    //   mainviewData: payload,                             // 或者按你已有的字段名传
    // });
    // // 数据加载完成，关闭 loading 状态
    // dispatch({ type: ActionType.UPDATE_MAIN_VIEW_LOADING, isMainViewLoading: false });
    // return payload;
  };
};

// [abandoned] opt 2: no streaming output progress manager
// export const getMainViewData = (fieldLevelDict: InteractionTypes.UIParamFieldLevelRangeDict, grantIDList: string[]) => {
//   return async function (dispatch: Dispatch<Action>) {
//     dispatch({
//       type: ActionType.GET_MAINVIEW_DATA,
//       mainviewData: await getMainViewDataAPI(fieldLevelDict, grantIDList),
//     });
//   };
// }

export const getMainViewImpactSummaryTableData = (grantIDList: string[]) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_MAINVIEW_IMPACT_SUMMARY_TABLE_DATA,
      payload: await getMainViewImpactSummaryTableDataAPI(grantIDList),
    });
  };
}

// (2) layout steps communication
export const updateMainViewGraphDivSize = (params: { width: number, height: number }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_MAINVIEW_GRAPH_DIV_SIZE,
      payload: params
    });
  };
}
export const getMainViewlayoutOptimizationParams = (params: any) => {
  return async function (dispatch: Dispatch<Action>) {
    dispatch({
      type: ActionType.GET_MAINVIEW_LAYOUT_OPTIMIZATION_PARAMS,
      payload: await getMainViewlayoutOptimizationParamsAPI(params),
    });
  };
}

export const isOptimizingMainViewLayoutFinished = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_OPTIMIZING_MAINVIEW_LAYOUT_FINISHED,
      isOptimizingMainViewLayoutFinished: params
    });
  };
}

export const isShowLeafNode = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_LEAF_NODE,
      isShowLeafNode: params
    });
  };
};
export const updateFieldLevelRange = (params: InteractionTypes.UIParamFieldLevelRangeDict) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_FIELD_LEVEL_RANGE,
      fieldLevelRange: params
    });
  };
};
export const updateContextMenuImpactEntity = (params: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CONTEXT_MENU_IMPACT_ENTITY,
      contextMenuImpactEntity: params
    });
  };
};
export const updateContextMenuPosition = (params: { left: number, top: number }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CONTEXT_MENU_POSITION,
      contextMenuPosition: params
    });
  };
};
export const isShowContextMenu = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_CONTEXT_MENU,
      isShowContextMenu: params
    });
  };
};
export const updateLeafNodeSizeScaleForHighlightedGrantField = (leafNodeSizeScale: any, leafNodeSizeScaleType: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LEAF_NODE_SIZE_SCALE_FOR_HIGHLIGHTED_GRANT_FIELD,
      leafNodeSizeScaleForHighlightedGrantField: leafNodeSizeScale,
      leafNodeSizeScaleType: leafNodeSizeScaleType,
    });
  };
};
export const updateLeafNodeSizeScale = (leafNodeSizeScale: any, leafNodeSizeScaleType: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LEAF_NODE_SIZE_SCALE,
      leafNodeSizeScale: leafNodeSizeScale,
      leafNodeSizeScaleType: leafNodeSizeScaleType,
    });
  };
};
export const updatePredictionGrantIDList4PIView = (predictedGrantIDList: string[], predictedGrantIDListGlobal: string[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PREDICTION_GRANTIDLIST_4_PI_VIEW,
      predictedGrantIDList: predictedGrantIDList,
      predictedGrantIDListGlobal: predictedGrantIDListGlobal,
    });
  };
};
export const updateWordleEntity = (params: { entity: string, fieldID: string }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_WORDLE_ENTITY,
      wordleEntity: params
    });
  };
};
export const updateWordlePosition = (params: { left: number, top: number }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_WORDLE_POSITION,
      wordlePosition: params
    });
  };
};
export const isShowWordle = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_WORDLE,
      isShowWordle: params
    });
  };
};
export const updateSelectedImpactEntityField = (params: { [entity: string]: string }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SELECTED_IMPACT_ENTITY_FIELD,
      payload: params
    });
  };
};
export const isShowPredictionFlow = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_PREDICTION_FLOW,
      isShowPredictionFlow: params
    });
  };
};
export const isShowHistoricalFlow = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_HISTORICAL_FLOW,
      isShowHistoricalFlow: params
    });
  };
};
export const updatePredictionSearchResult = (params: MainViewTypes.PredictionSearchResult) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PREDICTION_SEARCH_RESULT,
      predictionSearchResult: params
    });
  };
};
export const updateNodePositionList = (params: MainViewTypes.NodePosition[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_NODE_POSITION_LIST,
      nodePositionList: params
    });
  };
};

export const updateBubbleTreemapGeometryGroup = (params: MainViewTypes.BubbleTreemapGeometryGroup[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_BUBBLE_TREEMAP_GEOMETRY_GROUP,
      bubbleTreemapGeometryGroup: params
    });
  };
};

export const updateBubbleTreemapEntityGroupList = (params: MainViewTypes.BubbleTreemapEntityTypeGroup[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_BUBBLE_TREEMAP_ENTITY_GROUP_LIST,
      bubbleTreemapEntityGroupList: params
    });
  };
};

export const updateBubbleTreemapCircumscribedRadiiDict = (params: {[key: string]: number}) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_BUBBLE_TREEMAP_CIRCUMSCRIBED_RADII_DICT,
      bubbleTreemapCircumscribedRadiiDict: params
    });
  };
};

export const updateIsInitializeBubbleTreemapFinished = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_INITIALIZE_BUBBLE_TREEMAP_FINISHED,
      payload: params
    });
  };
};

export const updateIsOptimizedBubbleTreemapFinished = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_OPTIMIZED_BUBBLE_TREEMAP_FINISHED,
      payload: params
    });
  };
};

export const updateLeafNodeInitialPositionList = (params: {
  leafNodePositionList: MainViewTypes.LeafNodePosition[],
  bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[]
}) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LEAF_NODE_INITIAL_POSITION_LIST,
      payload: params
    });
  };
};

export const updateLeafNodePositionList = (params: {
  leafNodePositionList: MainViewTypes.LeafNodePosition[],
  bubbleTreemapEntityTypeCenterXYList: MainViewTypes.BubbleTreemapCenterPositionWarpper[]
}) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_LEAF_NODE_POSITION_LIST,
      payload: params
    });
  };
};

export const updateIsEntityTypeGraphFinished = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_ENTITY_TYPE_GRAPH_FINISHED,
      isfinished: params
    });
  };
};
export const updateIsEntityFieldGraphFinished = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IS_ENTITY_FIELD_GRAPH_FINISHED,
      isfinished: params
    });
  };
};
export const updateEntityTypeLayoutData = (layoutResult: any) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ENTITY_TYPE_LAYOUT_DATA,
      payload: layoutResult,
    });
  };
};
export const updateEntityFieldGraph_NodeLinkData = (params: { nodes: MainViewTypes.EntityTypeNode[], links: MainViewTypes.EntityTypeLink[] }) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ENTITY_FIELD_GRAPH_NODE_LINK_DATA,
      entityFieldGraph_NodeLinkData: params
    });
  };
};
export const updateEntityFieldGraph_InputData = (params: any[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_ENTITY_FIELD_GRAPH_INPUT_DATA,
      entityFieldGraph_InputData: params
    });
  };
};



// (3) UI request
export const isShowPredictionGraph = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_PREDICTION_GRAPH,
      isShowPredictionGraph: params
    });
  };
}
export const isShowHistoricalGraph = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.IS_SHOW_HISTORICAL_GRAPH,
      isShowHistoricalGraph: params
    });
  };
}
export const setQueryViewFolded = (params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_QUERY_VIEW_FOLDED,
      payload: params
    });
  };
}


export const clearCheckboxSelection = ((params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CLEAR_CHECKBOX_SELECTION,
      payload: params
    });
  };
})
export const cleanMainviewGraph = ((params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.CLEAN_MAINVIEW_GRAPH,
      payload: params
    });
  };
})
export const setShowEntityFieldLevelGraph = ((params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_SHOW_ENTITY_FIELD_LEVEL_GRAPH,
      payload: params
    });
  };
})
export const setShowEntityTypeLevelGraph = ((params: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_SHOW_ENTITY_TYPE_LEVEL_GRAPH,
      payload: params
    });
  };
})
export const setContextMenuVisibilityAndPosition = ((params: TooltipTypes.MainviewContextMenu) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.SET_CONTEXT_MENU_VISIBILITY_AND_POSITION,
      payload: params
    });
  };
})
export const onClickImpactFieldNode = (params: MainViewTypes.HighlightedImpactFieldNode) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ONCLICK_IMPACT_FIELD_NODE,
      payload: params
    });
  };
};

export const updateHighlghtedGrantFieldID = (param: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_HIGHLGHTEED_GRANT_FIELD_ID,
      payload: param,
    });
  };
};

export const onClickGrantFieldNode = (params: MainViewTypes.HighlightedGrantFieldNode) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ONCLICK_GRANT_FIELD_NODE,
      payload: params
    });
  };
};
export const updateGrantFieldNodePosition = (param: {
  grantNodePositionList: MainViewTypes.GrantNodePosition[],
  isDrawGrantTypeNodeFinished: boolean,
}) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_GRANT_FIELD_NODE_POSITION,
      payload: param,
    });
  };
};
export const updateTopKEntityField = (param: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_TOP_K_FIELD,
      topKField: param,
    });
  };
};
export const updateTopKCitationFlow = (param: number) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_TOP_K_CITATION_FLOW,
      topKCitationFlow: param,
    });
  };
};
export const updateGrantGlyphType = (param: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_GRANT_GLYPH_TYPE,
      grantGlyphType: param,
    });
  };
};
export const updateImpactType = (param: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IMPACT_TYPE,
      impactType: param,
    });
  };
};
export const updateCitationFlowType = (param: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_CITATION_FLOW_TYPE,
      citationFlowType: param,
    });
  };
};
export const updateImpactStatisticsTypeList = (param: string[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IMPACT_STATISTICS_TYPE_LIST,
      impactStatisticsTypeList: param,
    });
  };
};
// ===== mainview (end) =====



// ===== loading related (begin) =====
export const updateGrantViewLoading = (param: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_GRANT_VIEW_LOADING,
      isGrantViewLoading: param,
    });
  };
};

export const updatePIViewLoading = (param: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_PI_VIEW_LOADING,
      isPIViewLoading: param,
    });
  };
};

export const updateImpactEntityViewLoading = (param: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IMPACT_ENTITY_VIEW_LOADING,
      isImpactEntityViewLoading: param,
    });
  };
};

export const updateImpactStatisticsViewLoading = (param: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_IMPACT_STATISRICS_VIEW_LOADING,
      isImpactStatisticsViewLoading: param,
    });
  };
};

export const updateMainViewLoading = (param: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_MAIN_VIEW_LOADING,
      isMainViewLoading: param,
    });
  };
};
// ===== loading related (end) =====



// user management
export const performLogin = (params: UserManagementTypes.UserLoginParams) => {
  return async function (dispatch: Dispatch<Action>) {
    const result = await getLoginResultAPI(params);
    if (result.access_token) {
      sessionStorage.setItem('token', result.access_token);
      if (params.remember) {
        localStorage.setItem('rememberMe', 'true');
        localStorage.setItem('token', result.access_token)
      } else {
        localStorage.removeItem('rememberMe');
        localStorage.removeItem('token');
      }
    }
    if (result.msg) {
      message.error(result.msg);
    }

    dispatch({
      type: ActionType.PERFORM_LOGIN,
      error: result.msg,
      isAuthenticated: result.is_authenticated,
      token: result.access_token,
      user: params.username,
    })
  }
}

export const performRegister = (params: UserManagementTypes.UserRegisterParams) => {
  return async function (dispatch: Dispatch<Action>){
    const result = await getRegisterResultAPI(params);
    if (result.msg) {
      message.error(result.msg);
    }
    dispatch({
      type:ActionType.PERFORM_REGISTER,
      error: result.msg,
      registerStatus: result.status,
    })
  }
}

export const performDeleteAccount = (params: UserManagementTypes.UserLoginParams) => {
  return async function (dispatch: Dispatch<Action>){
    const result = await getDeleteAccountResultAPI(params);
    if (result.msg) {
      message.error(result.msg);
    }
    dispatch({
      type:ActionType.PERFORM_DELETE_ACCOUNT,
      error: result.msg,
      deleteStatus: result.status,
    })
  }
}

export const performForgetPassword = (params: UserManagementTypes.ForgetPasswordParams) => {
  return async function (dispatch: Dispatch<Action>){
    const result = await getForgetPasswordResultAPI(params);
    if (result.status) {
      message.success(result.msg);
    } else {
      message.error(result.msg);
    }
    dispatch({
      type:ActionType.PERFORM_FORGET_PASSWORD,
      error: result.msg,
      forgetStatus: result.status,
    })
  }
}

export const performResetPassword = (params: UserManagementTypes.ResetPasswordParams) => {
  return async function (dispatch: Dispatch<Action>){
    const result = await getResetPasswordResultAPI(params);
    if (result.status) {
      message.success(result.msg);
    } else {
      message.error(result.msg);
    }
    dispatch({
      type:ActionType.PERFORM_RESET_PASSWORD,
      error: result.msg,
      resetStatus: result.status,
    })
  }
}

export const performVerifyEmail = (params: UserManagementTypes.VerifyEmailParams) => {
  return async function (dispatch: Dispatch<Action>){
    const result = await getVerifyEmailResultAPI(params);
    if (result.status) {
      message.success(result.msg);
    } else {
      message.error(result.msg);
    }
    dispatch({
      type:ActionType.PERFORM_VERIFY_EMAIL,
      error: result.msg,
      verifyStatus: result.status,
    })
  }
}
